import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import MeetingData from 'components/installation/viewDetails/meetingData/meetingData';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const MeetingDetail = ({
  getMeetingById,
  meetingById,
  cancelMeeting,
  completeMeeting,
  match,
  history,
  location,
}) => {
  const [details, setDetails] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [siteId, setSiteId] = useState('');
  const [isCancelModal, setIsCancelModal] = useState(false);

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getMeetingById(match?.params?.id);
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (meetingById) {
      setDetails(meetingById);
      // Meeting site_id — not localStorage viewDetail (can be another site).
      if (meetingById.site_id != null && meetingById.site_id !== '') {
        setSiteId(meetingById.site_id);
      }
    }
  }, [meetingById]);

  const handleModalHide = () => setIsModal(false);

  const handleCancelModalHide = () => {
    setIsCancelModal(false);
    history.goBack();
  };

  const handleCancel = async () => {
    const requestData = {
      meeting_id: match?.params?.id,
    };
    (async () => {
      setIsLoading(true);
      const res = await cancelMeeting(requestData);
      setIsLoading(false);
      if (res) {
        setIsCancelModal(true);
      }
    })();
  };
  const handleComplete = async () => {
    const requestData = {
      meeting_id: match?.params?.id,
    };
    await completeMeeting(requestData).then(async (response) => {
      if (response) {
        setIsModal(true);
      }
    });
  };

  const headerBtns = () => {
    return (
      <>
        {details &&
        (details.status === 'Canceled' ||
          details.status === 'Completed') ? null : (
          <Button onClick={handleComplete} className="btn btn-primary">
            {localization.markComplete}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        )}
      </>
    );
  };
  return (
    <Layout
      title={localization.scheduleMeeting}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/meeting-history/${siteId}`}
    >
      {details && Object.keys(details).length !== 0 ? (
        <MeetingData details={details} />
      ) : null}
      {details &&
      (details.status === 'Canceled' ||
        details.status === 'Completed') ? null : (
        <div className="form-group btn-group d-xs-flexflow-wrap pad-0">
          <Button className="btn btn-transparent" onClick={handleCancel}>
            {localization.cancelMeeting}
          </Button>
          <Link
            to={`${baseUrl}/schedule-meeting/${details?.site_id ?? siteId}/${match.params.id}`}
            className="btn btn-transparent"
          >
            {localization.rescheduleMeeting}
          </Link>
        </div>
      )}
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingCompleted}</h5>
          <Link
            to={`${baseUrl}/meeting-history/${details?.site_id ?? siteId}`}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      {/* Cancel PopUp */}
      <ModalPop
        title={localization.conf}
        show={isCancelModal}
        handleModalHide={handleCancelModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingCancelSuccess}</h5>
          <Button
            onClick={handleCancelModalHide}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

MeetingDetail.propTypes = {};

export default MeetingDetail;
